// @flow

import { store } from '../../network/reduce';
import type { DynamicKey } from '../../types/dynamicKeyType';
import { SAVE_CURRENCIES_LIST, SAVE_DYNAMIC_KEYS_LIST } from './dynamicKeysReducer';
import dynamicKeysApi from '../../network/api/dynamicKeysApi';
import { currenciesSymbols } from '../../const';
import type { SelectConvertorMap } from '../../types/commonTypes';

export const fetchAllDynamicKeys = () =>
  (dispatch: () => void) => dynamicKeysApi.fetchAll()
    .then(response => response.json())
    .then((response) => {
      dispatch(saveDynamicKeysList(response.reduce((map, obj) => {
        map[obj.key] = {
          value: obj.value,
          id: obj.id,
          key: obj.key,
        };
        return map;
      }, {})));
    })
    .catch(console.error);

export const fetchAllCurrencies = () =>
  (dispatch: () => void) => dynamicKeysApi.fetchAllCurrencies()
    .then(response => response.json())
    .then((response) => {
      dispatch(saveCurrencies((response ?
        response
          .reduce((acc, cur) => {
            acc[cur.currencyTo] = {
              convertorTo: cur.currencyTo,
              symbol: currenciesSymbols[cur.currencyTo] || cur.currencyTo,
              convertorFactor: cur.currateMar,
              order: cur.order,
            };
            return acc;
          }, {}) :
        {})));
    })
    .catch(console.error);


export const saveDynamicKeysList = (dynamicKeys: DynamicKey[]) =>
  (dispatch: () => void) => {
    dispatch(store(SAVE_DYNAMIC_KEYS_LIST, dynamicKeys));
  };

export const saveCurrencies = (currencies: SelectConvertorMap) =>
  (dispatch: () => void) => {
    dispatch(store(SAVE_CURRENCIES_LIST, currencies));
  };
